module.exports = __webpack_public_path__ + "static/media/heart.d0a3a2bd.svg";